import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { DataTableResponse, DataTableRequest } from '../services/service-proxies';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class Api {
    constructor(private httpClient: HttpClient,
        private toastr: ToastrService,
        private translate: TranslateService) {

    }

    get<T>(action: string, params?: HttpParams): Observable<T> {
        return this.httpClient.get<T>(`${environment.apiBaseUrl}/${action}`, { params: params });
    }

    post(action: string, body: any): Observable<Object> {
        return this.httpClient.post(`${environment.apiBaseUrl}/${action}`, body);
    }

    put(action: string, body: any): Observable<Object> {
        return this.httpClient.put(`${environment.apiBaseUrl}/${action}`, body);
    }

    datatable(action: string, body: DataTableRequest): Observable<DataTableResponse> {
        return this.httpClient.post<DataTableResponse>(`${environment.apiBaseUrl}/${action}`, body);
    }

    download<T>(filename: string, action: string, params?: HttpParams): Observable<any> {
        return this.httpClient.get(`${environment.apiBaseUrl}/${action}`, { responseType: 'blob', observe: 'response' })
        .pipe(map((result: any) => {
            if(filename == '') {
                const contentDisposition = result.headers.get('content-disposition') || '';
                var patt = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var regex = contentDisposition.match(patt);
                filename = regex[1].replace(/['"]/g, '');
            }
            var file = new Blob([result.body], {type: result.headers.get('Content-Type')});
            const downloadUrl = window.URL.createObjectURL(file);
            var fileLink = document.createElement('a');
            fileLink.href = downloadUrl;
            fileLink.download = filename;
            document.body.appendChild(fileLink);
            fileLink.click();
            setTimeout(function() {
                document.body.removeChild(fileLink);
                window.URL.revokeObjectURL(downloadUrl);
            }, 100);
        }));
    }

    downloadPdf(action: string): Observable<HttpResponse<Blob>> {
        let headers = new HttpHeaders();
        headers = headers.append('Accept', 'application/pdf');
    
        return this.httpClient.get(`${environment.apiBaseUrl}/${action}`, {
                headers: headers,
                observe: 'response',
                responseType: 'blob'
            });
    }

    exportCsv(action: string, data): Observable<any> {
        return this.httpClient.post(`${environment.apiBaseUrl}/${action}`, data, { responseType: 'blob', observe: 'response' })
            .pipe(map((result: any) => {
                const contentDisposition = result.headers.get('content-disposition') || '';
                var patt = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var regex = contentDisposition.match(patt);
                var filename = regex[1].replace(/['"]/g, '');
                var file = new Blob([result.body], {type: result.headers.get('Content-Type')});
                const downloadUrl = window.URL.createObjectURL(file);
                const fileLink = document.createElement('a');
                fileLink.href = downloadUrl;
                fileLink.download = filename;
                document.body.appendChild(fileLink);
                fileLink.click();
                setTimeout(function() {
                    document.body.removeChild(fileLink);
                    window.URL.revokeObjectURL(downloadUrl);
                }, 100);
            }));
    }
}
